import { Injectable } from "@angular/core";
import { AbstractControl } from "@angular/forms";
import { ErrorMessageConst } from "@core-constants/error-message.const";
import { TranslateService } from "./translate.service";

@Injectable({ providedIn: 'root' })
export class ValidationMessageService
{
  constructor(private translateService: TranslateService) { }

  public getErrorMessage(control: AbstractControl | null): string
  {
    if (!control)
    {
      return '';
    }

    // Definimos los tipos de error y su mensaje base
    const errorMessages: { [key: string]: (error?: any) => string; } = {
      required: () => this.translateService.getElement(ErrorMessageConst.FormRequired),
      pattern: () => this.translateService.getElement(ErrorMessageConst.FormPattern),
      invalid: () => this.translateService.getElement(ErrorMessageConst.FormInvalid),
      maxlength: (error) => this.translateService.getElement(ErrorMessageConst.FormMaxLength, error?.requiredLength),
      minlength: (error) => this.translateService.getElement(ErrorMessageConst.FormMinLength, error?.requiredLength),
      email: () => this.translateService.getElement(ErrorMessageConst.FormEmail),
      backend: (error) => error // mensaje ya viene del backend
    };

    // Busca el primer error activo en el control
    const errorKey = Object.keys(errorMessages).find(key => control.hasError(key));
    if (!errorKey)
    {
      return '';
    }

    const error = control.getError(errorKey);
    return errorMessages[errorKey](error);
  }

  public getAllErrorsMessage(control: AbstractControl | null): string
  {
    if (!control)
    {
      return '';
    }

    // Definimos los tipos de error y su mensaje base
    const errorMessages: { [key: string]: (error?: any) => string; } = {
      required: () => this.translateService.getElement(ErrorMessageConst.FormRequired),
      pattern: () => this.translateService.getElement(ErrorMessageConst.FormPattern),
      invalid: () => this.translateService.getElement(ErrorMessageConst.FormInvalid),
      maxlength: (error) => this.translateService.getElement(ErrorMessageConst.FormMaxLength, error?.requiredLength),
      minlength: (error) => this.translateService.getElement(ErrorMessageConst.FormMinLength, error?.requiredLength),
      email: () => this.translateService.getElement(ErrorMessageConst.FormEmail),
      backend: (error) => error // mensaje ya viene del backend
    };

    // Obtiene todos los errores activos
    const activeErrors = Object.keys(control.errors || {});

    if (activeErrors.length === 0)
    {
      return '';
    }

    // Genera los mensajes correspondientes
    const messages = activeErrors
      .filter(key => errorMessages[key])
      .map(key => errorMessages[key](control.getError(key)));

    return messages.join('\n');
  }

}
